import clsx from 'clsx';
import { HTMLProps, ReactNode } from 'react';

import { LocaleEnum } from 'schema/locale';

import {
  RegionAPACIcon,
  RegionBritainIcon,
  RegionEuropeIcon,
  RegionGermanIcon,
  RegionNewZealandIcon,
  RegionUSAIcon
} from '@ag1/ui';
import styles from './StoreIcon.module.scss';
import { useLocale } from '../../hooks/useLocale';

interface Props extends HTMLProps<HTMLDivElement> {
  circle?: boolean;
  className?: string;
}

const iconMap: Record<LocaleEnum, ReactNode> = {
  [LocaleEnum.deEU]: <RegionGermanIcon />,
  [LocaleEnum.enEU]: <RegionEuropeIcon />,
  [LocaleEnum.enUK]: <RegionBritainIcon />,
  [LocaleEnum.enUS]: <RegionUSAIcon />,
  [LocaleEnum.apacUS]: <RegionAPACIcon />,
  [LocaleEnum.enAU]: <RegionAPACIcon />,
  [LocaleEnum.enNZ]: <RegionNewZealandIcon />,
  [LocaleEnum.enJP]: <RegionUSAIcon />,
  [LocaleEnum.jaJP]: <RegionUSAIcon />,
  [LocaleEnum.enDev]: null,
  [LocaleEnum.enQa]: null,
  [LocaleEnum.deQa]: null,
  [LocaleEnum.enAud]: null,
  [LocaleEnum.enNzd]: null,
  [LocaleEnum.enEud]: null,
  [LocaleEnum.deEud]: null,
  [LocaleEnum.enUkd]: null,
  [LocaleEnum.nlEU]: <RegionEuropeIcon />,
  [LocaleEnum.seEU]: <RegionEuropeIcon />,
  [LocaleEnum.esEU]: <RegionEuropeIcon />,
  [LocaleEnum.frEU]: <RegionEuropeIcon />
};

const StoreIcon = ({ circle, className, ...res }: Props) => {
  const locale = useLocale();
  return (
    <div className={clsx(className, styles.wrapper, circle && styles.circle)} {...res}>
      {iconMap[locale]}
    </div>
  );
};

export default StoreIcon;
